<template>
  <div class="z2-conversation-header border-bottom">
    <img
      class="z2-avatar mb-1 pointer"
      :src="conversation?.avatar || '/assets/images/no-avatar.png'"
      @click="onShowProfile" />
    <div class="d-flex flex-grow-1 flex-column mb-1 ms-2">
      <div class="d-flex align-items-center">
        <span
          class="font-16 fw-500 me-1 trim-text-1-line"
          :style="{ 'max-width': isExpand ? 'calc(100vw - 900px)' : 'calc(100vw - 600px)' }"
          >
          {{ conversation.swName && conversation.swName.length > 0 ? conversation.swName : conversation.toName }}
        </span>
        <div @click="showPopOver">
          <IconV2
            class="pointer"
            name="v2-edit" />
        </div>
      </div>
      <span
        v-if="!conversation.group"
        class="font-14 fw-300">
        {{ onlineStatus.lastOnlineStr }}
      </span>
      <span v-else>{{ members.length }} thành viên</span>
    </div>
    <div class="mb-1 d-flex align-items-center">
      <el-input
        v-if="isSearch"
        :value="searchKey"
        @input="changeSearchKey"
        size="small"
        class="input-radius"
        style="width: 300px"
        placeholder="Tìm tin nhắn trong hội thoại"
        @keydown.enter.exact.native="onSearchMessage"
        >
        <div
          slot="suffix"
          class="mt-1 d-flex align-items-center justify-content-center pointer"
          style="width: 24px; height: 24px; background-color: #eff5ff; border-radius: 12px"
          @click="isSearch = false">
          <IconV2
            name="v2-search"
            color="#3484F0" />
        </div>
      </el-input>
      <div
        v-else
        class="pointer"
        @click="isSearch = true">
        <IconV2
          name="v2-search"
          size="lg" />
      </div>

      <div
        class="rounded z2-button-filter"
        @click="conversation.unreadCount ? unread(conversation.id) : setRead(conversation.id)">
        <el-tooltip
          effect="dark"
          :content="'Đánh dấu chưa đọc'"
          placement="top">
          <IconV2
            :name="conversation.unreadCount ? 'v2-read' : 'v2-unread'"
            size="lg" />
        </el-tooltip>
      </div>
      <div
        class="z2-btn z2-btn-circle"
        @click="onExpandConversation">
        <i
          class="font-16 fw-bold"
          :class="isExpand ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
      </div>
    </div>

    <el-dialog
      :title="'Đặt biệt danh cho ' + conversation.toName"
      width="400px"
      v-if="showPopOverSwName"
      :visible.sync="showPopOverSwName"
      destroy-on-close>
      <div>
        <el-input
          placeholder="Nhập biệt danh"
          type="textarea"
          :rows="3"
          v-model="conversation.swName"
          @keydown.enter.exact.native="saveSwName"
          resize="none"></el-input>
        <div class="d-flex justify-content-end mt-2">
          <el-button
            type="primary"
            size="mini"
            plain
            @click="saveSwName()">
            Lưu
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      v-if="showProfile && profile && !conversation.group"
      width="300px"
      :visible.sync="showProfile"
      title="Thông tin tài khoản"
      class="dialogProfileV2">
      <div
        slot="title"
        class="font-16 fw-500">
        Thông tin tài khoản
      </div>
      <ProfileInfoPopupV2
        :data="profile"
        :conversation="conversation"
        @closeProfile="closeProfile" />
    </el-dialog>

    <el-dialog
      v-if="showProfile && conversation.group"
      width="360px"
      :visible.sync="showProfile"
      title="Thông tin nhóm"
      :destroy-on-close="true">
      <GroupInfoPopup
        :members="members.length"
        :avatar="conversation.avatar || '/assets/images/no-avatar.png'"
        :name="conversation.toName"
        :closeGroupInfoPopup="showProfile"
        :idConversationGroup="conversation" />
    </el-dialog>
  </div>

  <!-- <div>Chặn</div> -->
  <!-- <div>Ket ban</div> -->
  <!-- <div>Ghim</div> -->
  <!-- <div>Dialog Giao viec</div> -->
  <!-- <div>Dialog Thong tin nhom</div> -->
  <!-- <div>Dialog profile</div> -->
  <!-- <div>Dialog Lich su gan tag</div> -->
  <!-- <div>Dialog Tao nhom</div> -->
  <!-- <div>Dialog Them thanh vien</div> -->
  <!-- <div>Dialog Dat biet danh</div> -->
</template>

<script>
import IconV2 from "./common/IconV2.vue";
import ProfileInfoPopupV2 from "./ProfileInfoPopupV2";
import GroupInfoPopup from "@/components/GroupInfoPopup";

export default {
  props: ["conversation", "onlineStatus", "isExpand", "profile", "members", "searchKey"],
  components: {
    IconV2,
    ProfileInfoPopupV2,
    GroupInfoPopup,
  },
  data() {
    return {
      showPopOverSwName: false,
      showProfile: false,
      isSearch: false,
    };
  },
  methods: {
    onExpandConversation() {
      this.$emit("onClickExpand");
    },
    showPopOver() {
      this.showPopOverSwName = true;
    },
    saveSwName() {
      this.$http.get("/api/conversation/setSwName", {
        params: {
          accountId: this.conversation.accountId,
          conversationId: this.conversation.id,
          swName: this.conversation.swName,
        },
      });
      this.showPopOverSwName = false;
    },
    onShowProfile() {
      if (!this.conversation.page) {
        this.showProfile = true;
      }
    },
    closeProfile() {
      this.showProfile = false;
    },
    changeSearchKey(e) {
      this.$emit("changeSearchKey", e);
    },
    onSearchMessage() {
      this.$emit('onSearchMessage')
    }
  },
};
</script>

<style lang="scss">
.dialogProfileV2 {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.input-radius {
  input {
    border-radius: 1rem;
  }
}
</style>